export enum TodoDescriptorType {
    FolderId = 'FolderId',
    MyDay = 'MyDay',
    DueDate = 'DueDate',
}
